import React from "react";
import { Box, Typography } from "@mui/material";

const PageTitle = ({ title, subTitle = "", mb = 3, subTitleMb = 0 }) => {
  return (
    <Box sx={{ mb: mb }}>
      <Typography variant="h5">{title}</Typography>
      {subTitle && (
        <Typography variant={"body2"} sx={{ mt: subTitleMb }}>
          {subTitle}
        </Typography>
      )}
    </Box>
  );
};

export default PageTitle;
